export default __webpack_public_path__ + "static/media/tick-icon-pink.6628f261.svg";